import { TileStrictPosition } from "@progress/kendo-react-layout";

export interface TileStrictPositionSorted extends TileStrictPosition {
  sortOrder: number;
}
export interface IPageLayout {
  id?: string,
  pageName: string,
  name?: string,
  description?: string;
  positions: TileStrictPositionSorted[]
}
export const LOAD_PAGE_LAYOUTS = "LOAD_PAGE_LAYOUTS";
export interface LoadPageLayoutsAction {
  type: typeof LOAD_PAGE_LAYOUTS;
}
export const loadPageLayouts = (): LoadPageLayoutsAction => {
  return {
    type: LOAD_PAGE_LAYOUTS
  };
}
export const LOAD_PAGE_LAYOUTS_SUCCESS = "LOAD_PAGE_LAYOUTS_SUCCESS";
export interface LoadPageLayoutsSuccessAction {
  type: typeof LOAD_PAGE_LAYOUTS_SUCCESS;
  payload: { layouts: IPageLayout[] };
}
export const loadPageLayoutsSuccess = (layouts: IPageLayout[]): LoadPageLayoutsSuccessAction => {
  return {
    type: LOAD_PAGE_LAYOUTS_SUCCESS,
    payload: { layouts }
  };
}
export const UPDATE_PAGE_LAYOUT = "UPDATE_PAGE_LAYOUT";
export interface UpdatePageLayoutAction {
  type: typeof UPDATE_PAGE_LAYOUT;
  payload: { layout: IPageLayout };
}
export const updatePageLayout = (layout: IPageLayout): UpdatePageLayoutAction => {
  return {
    type: UPDATE_PAGE_LAYOUT,
    payload: { layout }
  };
}
export const UPDATE_PAGE_LAYOUT_SUCCESS = "UPDATE_PAGE_LAYOUT_SUCCESS";
export interface UpdatePageLayoutSuccessAction {
  type: typeof UPDATE_PAGE_LAYOUT_SUCCESS;
  payload: { layout: IPageLayout };
}
export const updatePageLayoutSuccess = (layout: IPageLayout): UpdatePageLayoutSuccessAction => {
  return {
    type: UPDATE_PAGE_LAYOUT_SUCCESS,
    payload: { layout }
  };
}
export const CREATE_PAGE_LAYOUT = "CREATE_PAGE_LAYOUT";
export interface CreatePageLayoutAction {
  type: typeof CREATE_PAGE_LAYOUT;
  payload: { layout: IPageLayout };
}
export const createPageLayout = (layout: IPageLayout): CreatePageLayoutAction => {
  return {
    type: CREATE_PAGE_LAYOUT,
    payload: { layout }
  };
}
export const CREATE_PAGE_LAYOUT_SUCCESS = "CREATE_PAGE_LAYOUT_SUCCESS";
export interface CreatePageLayoutSuccessAction {
  type: typeof CREATE_PAGE_LAYOUT_SUCCESS;
  payload: { layout: IPageLayout };
}
export const createPageLayoutSuccess = (layout: IPageLayout): CreatePageLayoutSuccessAction => {
  return {
    type: CREATE_PAGE_LAYOUT_SUCCESS,
    payload: { layout }
  };
}
export const DELETE_PAGE_LAYOUT = "DELETE_PAGE_LAYOUT";
export interface DeletePageLayoutAction {
  type: typeof DELETE_PAGE_LAYOUT;
  payload: { layout: IPageLayout };
}
export const deletePageLayout = (layout: IPageLayout): DeletePageLayoutAction => {
  return {
    type: DELETE_PAGE_LAYOUT,
    payload: { layout }
  };
}
export const DELETE_PAGE_LAYOUT_SUCCESS = "DELETE_PAGE_LAYOUT_SUCCESS";
export interface DeletePageLayoutSuccessAction {
  type: typeof DELETE_PAGE_LAYOUT_SUCCESS;
  payload: { layouts: IPageLayout[] };
}
export const deletePageLayoutSuccess = (layouts: IPageLayout[]): DeletePageLayoutSuccessAction => {
  return {
    type: DELETE_PAGE_LAYOUT_SUCCESS,
    payload: { layouts }
  };
}

export const CLEAR_SAVED_PAGE_LAYOUT = "CLEAR_SAVED_PAGE_LAYOUT";
export interface ClearSavedPageLayoutAction {
  type: typeof CLEAR_SAVED_PAGE_LAYOUT;
}
export const clearSavedPageLayout = (): ClearSavedPageLayoutAction => {
  return {
    type: CLEAR_SAVED_PAGE_LAYOUT
  };
}

export type PreferenceActions = 
LoadPageLayoutsAction | 
LoadPageLayoutsSuccessAction | 
UpdatePageLayoutAction | 
UpdatePageLayoutSuccessAction | 
CreatePageLayoutAction | 
CreatePageLayoutSuccessAction | 
DeletePageLayoutAction | 
DeletePageLayoutSuccessAction |
ClearSavedPageLayoutAction;